import React from 'react';
import { motion } from 'framer-motion';

export function LoadingIndicator() {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex justify-start"
    >
      <div className="bg-white rounded-lg p-3 max-w-[80%] flex items-center space-x-2 shadow-message border border-gray-200">
        <div className="flex items-center space-x-1.5">
          <motion.div 
            className="w-2.5 h-2.5 bg-brand-400 rounded-full"
            animate={{ scale: [0.8, 1.2, 0.8] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          />
          <motion.div 
            className="w-2.5 h-2.5 bg-brand-500 rounded-full"
            animate={{ scale: [0.8, 1.2, 0.8] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
          />
          <motion.div 
            className="w-2.5 h-2.5 bg-brand-600 rounded-full"
            animate={{ scale: [0.8, 1.2, 0.8] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
          />
        </div>
      </div>
    </motion.div>
  );
}